var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "renwufwlistitem",
      on: {
        click: function ($event) {
          return _vm.triggleEvent("detail")
        },
      },
    },
    [
      !_vm.pic
        ? _c("img", {
            staticClass: "item-preview",
            attrs: { src: require("../../images/preview-defalt-new.png") },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.pic
        ? _c("img", { staticClass: "item-preview", attrs: { src: _vm.pic } })
        : _vm._e(),
      _vm._v(" "),
      _vm.house.is_zd_fang && _vm.house.is_zd_fang == "yes"
        ? _c("img", {
            staticClass: "zd-house",
            attrs: { src: require("../../images/icon-zd-house.png") },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.house.vr_addr && _vm.house.is_vr == "是"
        ? _c("img", {
            staticClass: "house-vr-img",
            attrs: { src: require("../../images/icon-vr.png") },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "house-info" }, [
        _c("div", { staticClass: "house-info-title" }, [
          _vm._v(
            _vm._s(_vm.house.xiaoqumingcheng_id) +
              " （" +
              _vm._s(_vm.house.bianhao) +
              "）"
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "other" }, [_vm._v(_vm._s(_vm.house.shi))]),
        _vm._v(" "),
        _c("div", { staticClass: "other" }, [
          _vm._v(_vm._s(_vm.house.taoneimianji) + "m²"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "money" }, [
          _c("span", { staticClass: "amout" }, [
            _vm._v(_vm._s(_vm.house.shoujia) + "万"),
          ]),
        ]),
        _vm._v(" "),
        _vm.house.biaoqian && _vm.house.biaoqian.length > 0
          ? _c(
              "div",
              { staticClass: "house-info-tags" },
              _vm._l(_vm.house.biaoqian, function (tag) {
                return _c("span", { staticClass: "tag" }, [
                  _vm._v(_vm._s(tag.name)),
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "house-gn-list" }, [
          _vm.house.is_have_ys && _vm.house.is_have_ys == "yes"
            ? _c("div", { staticClass: "house-key" }, [_vm._v("钥匙房")])
            : _vm._e(),
          _vm._v(" "),
          _vm.house.vr_addr && _vm.house.is_vr == "是"
            ? _c("img", {
                staticClass: "house-vr",
                attrs: { src: require("../../images/icon-vr.png") },
              })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.house.dkzt == "已打卡"
          ? _c("div", { staticClass: "daka-status" }, [
              _vm._v("已打卡 " + _vm._s(_vm.house.dksj)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.house.pkr
          ? _c("div", { staticClass: "daka-status" }, [
              _vm._v("陪看人：" + _vm._s(_vm.house.pkr)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "s-btn-group" }, [
          _c(
            "div",
            {
              staticClass: "s-btn",
              on: {
                click: function ($event) {
                  return _vm.triggleEvent("delete")
                },
              },
            },
            [_vm._v("删除")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "s-btn",
              on: {
                click: function ($event) {
                  return _vm.triggleEvent("peikan")
                },
              },
            },
            [
              _vm._v(
                "陪看" +
                  _vm._s(
                    _vm.house.pkr_list
                      ? "(" + _vm.house.pkr_list.length + ")"
                      : ""
                  )
              ),
            ]
          ),
          _vm._v(" "),
          _vm.house.dkzt != "已打卡" && !_vm.stopDaka
            ? _c(
                "div",
                {
                  staticClass: "s-btn",
                  on: {
                    click: function ($event) {
                      return _vm.triggleEvent("daka")
                    },
                  },
                },
                [_vm._v("打卡")]
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }